import axios from "axios";
const GITHUB_TOKEN = process.env.REACT_APP_GITHUB_TOKEN;

const fetchGithubProfileData = async (username) => {
  try {
    const headers = {
      Authorization: `Bearer ${GITHUB_TOKEN}`,
      Accept: "application/vnd.github.v3+json",
    };

    // Fetch user profile
    const profileResponse = await axios.get(`https://api.github.com/users/${username}`, { headers });

    // Fetch repositories
    const reposResponse = await axios.get(profileResponse.data.repos_url, { headers });

    // Fetch commits and language data for each repository
    const commitData = await Promise.all(
      reposResponse.data.map(async (repo) => {
        const commitsResponse = await axios.get(repo.commits_url.replace("{/sha}", ""), { headers });
        const commits = commitsResponse.data.map((commit) => ({
          message: commit.commit.message,
          date: commit.commit.author.date,
        }));

        return {
          repo_name: repo.name,
          repo_description: repo.description, // Include repository description
          language: repo.language, // Fetch language used in the repo
          stars: repo.stargazers_count, // Fetch stars count
          commits: commits,
        };
      })
    );

    // Calculate overall scores for each language used
    const languageScores = commitData.reduce((acc, repo) => {
      const { language, stars, commits } = repo;

      // Initialize the language score if not present
      if (!acc[language]) {
        acc[language] = { totalStars: 0, totalCommits: 0, repoCount: 0 };
      }

      // Aggregate the scores for the language
      acc[language].totalStars += stars;
      acc[language].totalCommits += commits.length;
      acc[language].repoCount += 1;

      return acc;
    }, {});
    console.log(commitData);
    // Final scores calculation (you can adjust this logic based on your requirements)
    const finalLanguageScores = Object.keys(languageScores).map((language) => {
      const { totalStars, totalCommits, repoCount } = languageScores[language];

      // Calculate the score based on stars and commits (or use any other factors)
      const languageScore = Math.round((totalStars * 0.6) + (totalCommits * 0.4)); // Example weighting

      return {
        language,
        score: languageScore,
        totalRepos: repoCount,
      };
    });

    // Structure the final data
    return {
      username: profileResponse.data.name,
      bio: profileResponse.data.bio, // Include bio
      followers: profileResponse.data.followers,
      following: profileResponse.data.following,
      total_repos: reposResponse.data.length,
      repos: reposResponse.data.map((repo) => ({
        name: repo.name,
        description: repo.description, // Include repo description
        language: repo.language, // Include language used in the repo
      })),
      commit_data: commitData,
      stars: commitData.stars,
      language_scores: finalLanguageScores, // Return language scores
    };
  } catch (error) {
    console.error("Error fetching GitHub data:", error);
    return null; // Return null in case of an error
  }
};

export default fetchGithubProfileData;
